// extracted by mini-css-extract-plugin
export default {"strip":"uhzz7","root":"oBsLK","arrow":"NHlMP","textArea":"TE69L","title":"HXEYE","subTitle":"_4WPcr"};